import React from "react";
import { Card, CardContent, Typography, Box, Button, Chip } from "@mui/material";

interface BookingRequestCardProps {
  ownerName: string;
  petInfo: string;
  serviceType: string;
  dateRange: string;
  duration: string;
  price: number;
  onAccept: () => void;
  onDecline: () => void;
}

const BookingRequestCard: React.FC<BookingRequestCardProps> = ({
  ownerName,
  petInfo,
  serviceType,
  dateRange,
  duration,
  price,
  onAccept,
  onDecline,
}) => {
  return (
    <Card
      sx={{
        mb: 2,
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1, minWidth: "250px" }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
              {ownerName}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 0.5 }}
            >
              {petInfo}
            </Typography>
            <Chip
              label={serviceType}
              size="small"
              sx={{
                backgroundColor: "primary.light",
                color: "white",
                fontWeight: 500,
                mb: 1,
              }}
            />
            <Typography variant="body2" color="text.secondary">
              {dateRange} · {duration}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 1.5,
            }}
          >
            <Typography
              variant="h5"
              sx={{ color: "primary.main", fontWeight: 700 }}
            >
              ${price}
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={onDecline}
                sx={{ minWidth: "90px" }}
              >
                Decline
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={onAccept}
                sx={{ minWidth: "90px" }}
              >
                Accept
              </Button>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BookingRequestCard;
